const LOADING_COMPONENT_LOADER_PROPS = {
    altText: 'loading',
    animation: 'animation_loader_primary',
    height: '56px',
    width: '56px',
    visible: true,
  },
  LOADING_COMPONENT_PARAGRAPH_PROPS = {
    testId: 'loading-paragraph',
  },
  LOADING_COMPONENT_TITLE_PROPS = {
    showBuilder: false,
    testId: 'loading-title',
  },
  LOADING_COMPONENT_BUTTON_PROPS = {
    type: 'PRIMARY',
    underline: true,
  };

export {
  LOADING_COMPONENT_BUTTON_PROPS,
  LOADING_COMPONENT_LOADER_PROPS,
  LOADING_COMPONENT_PARAGRAPH_PROPS,
  LOADING_COMPONENT_TITLE_PROPS,
};
